var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-feature"},[_vm._t("cover"),_vm._v(" "),(_vm.btnName)?_c('div',{staticClass:"btn-action"},[_vm._v(_vm._s(_vm.btnName))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }